var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentPendent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.901 334.001L86.4531 165.43H327.349L380.802 334.001H139.901Z",
    fill: "white",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.617 295.688L124.06 211.942C122.757 207.826 125.829 203.629 130.143 203.629H199.158C201.941 203.629 204.399 205.428 205.241 208.085L231.797 291.83C233.1 295.946 230.028 300.143 225.715 300.143H156.7C153.917 300.143 151.458 298.344 150.617 295.688Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 150.165L161.146 70.8854C160.304 68.2343 157.846 66.4297 155.063 66.4297H84.6234C80.3046 66.4297 77.2328 70.6269 78.5406 74.7429L102.456 150.165",
    fill: "#669FDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.283 150.165L161.146 70.8854C160.304 68.2343 157.846 66.4297 155.063 66.4297H84.6234C80.3046 66.4297 77.2328 70.6269 78.5406 74.7429L102.456 150.165",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.752 90.4062L205.7 150.165",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.074 66.4297L219.626 150.165",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.804 321.089H89.7925L3.20312 48H206.507L238.903 150.166",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.356 297.621H114.822C110.944 297.621 107.512 295.112 106.341 291.417L65.2313 161.751C63.4115 156.018 67.6949 150.168 73.7118 150.168H278.531C282.409 150.168 285.841 152.677 287.012 156.372L289.881 165.426",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.199 288.328H337.194",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M242.432 263.801H329.426",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.65 239.27H321.645",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.871 214.742H274.753",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.9 290.291L170.489 268.758L169.496 265.631C168.685 263.076 167.002 260.861 164.701 259.487C156.986 254.884 151.04 247.042 149.438 238.136C146.888 223.963 156.306 212.477 170.479 212.477C184.652 212.477 198.207 223.963 200.757 238.136C201.973 244.883 200.473 251.022 197.036 255.604C194.851 258.519 194.167 262.29 195.267 265.762L196.215 268.753L231.303 290.286",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.596 150.166L151.186 133.96L150.238 130.969C149.138 127.497 149.822 123.726 152.007 120.811C155.444 116.229 156.944 110.09 155.728 103.343C153.178 89.17 139.623 77.6836 125.45 77.6836C111.277 77.6836 101.859 89.17 104.409 103.343C106.011 112.249 111.957 120.091 119.672 124.694C121.973 126.068 123.656 128.283 124.467 130.838L125.46 133.965L109.209 150.171",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPendent);
export default __webpack_public_path__ + "static/media/document-pendent.971eb2c9.svg";
export { ForwardRef as ReactComponent };